import { INPUT_TEXTAREA_DISPLAY_NAME } from "./core";
import createTestId from "../../../fabrics/createTestId";

export const createTestIdForInputTextAreaElement = createTestId(
    INPUT_TEXTAREA_DISPLAY_NAME,
);
